import React from "react";
import {inject, observer} from "mobx-react";

const BLOCS = 8;

/**
 * Animation de chargement de la zone principale : tant que la page attend ses données (ou son code),
 * un voile et une petite fenêtre animée recouvrent la page. L'animation n'apparaît qu'après un court délai (CSS),
 * pour ne pas clignoter sur les réponses rapides. Son habillage suit le thème choisi (_chargement.scss) :
 * anneau en classique, « NOW LOADING » et blocs pixel en jeu vidéo, cristal et barre ATB en Final Fantasy.
 *
 * @param toujours affiche l'animation sans regarder les requêtes (attente du code d'une page)
 */
const ChargementPage = inject("rootStore")(observer(({rootStore, toujours}) => {
    const visible = toujours || rootStore.savedDatasStore.chargementVisible;
    return (
        <div className={"chargement-page" + (visible ? " visible" : "")} role="status" aria-live="polite" aria-hidden={!visible}>
            <div className="chargement-barre"/>
            <div className="chargement-boite">
                <div className="chargement-anneau"/>
                <div className="chargement-cristal"/>
                <div className="chargement-titre">
                    <span className="chargement-texte">Chargement</span>
                    <span className="chargement-points"><span>.</span><span>.</span><span>.</span></span>
                </div>
                <div className="chargement-blocs">
                    {Array.from({length: BLOCS}, (_, i) => <span key={i} style={{animationDelay: (i * 0.12) + "s"}}/>)}
                </div>
            </div>
        </div>
    )
}));

export default ChargementPage;
